import axios from 'axios'
import router from "../../router/index"
import qs from "qs"
import {generatekey, sort} from '@/mixins/des.js'
import md5 from "js-md5"

axios.defaults.timeout = 30000;
axios.defaults.baseURL = process.env.DOMAIN_ENV;
axios.defaults.transformRequest = function (data) {

  return data instanceof FormData ? data : qs.stringify({ //此处的data类型判断为重要点，
    ...data
  });
};
axios.interceptors.request.use(
  config => {

    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    if (config.method === 'post') {
      if (config.data == undefined || config.data == '') config.data = {}
      config.data.keys = null;
      config.data.sign = null
      let openid = sessionStorage.getItem('token');
      let channelID = sessionStorage.getItem('appid');
      if (openid) {
        config.data.openid = openid;
      }
      if (channelID) {
        config.data.channelID = channelID;
      }
      const _t = Date.parse(new Date()) / 1000
      let keys = generatekey(16);
      config.data.keys = keys;
      config.data._t = _t
      config.data.sign = md5(keys + (openid ? openid : '') + _t + keys)
    } else if (config.method === 'get') {
      if (config.params == undefined || config.params == '') config.params = {}
      config.params.keys = null;
      config.params.sign = null
      let openid = sessionStorage.getItem('token');
      let channelID = sessionStorage.getItem('appid');
      if (openid) {
        config.params.openid = openid;
      }
      if (channelID) {
        config.params.channelID = channelID;
      }
      const _t = Date.parse(new Date()) / 1000
      let keys = generatekey(16);
      config.params._t = _t
      config.params.keys = keys;
      config.params.sign = md5(keys + (openid ? openid : '') + _t + keys)

    }

    return config
  },
  error => {
    return Promise.reject(error.response);
  });
axios.interceptors.response.use(
  response => {
    if (response.data.code == "-1") {
      router.push({path: '/login'})
      return false;
    } else {
      return response.data;
    }
  },
  error => {
    return Promise.reject(error.response)
  });
export default axios;



// WEBPACK FOOTER //
// ./src/config/httpConfig/http.js